import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Helper } from 'src/app/accountancy/utilities/classes/helper.class';
import { ReimbursementItemHistory } from 'src/app/accountancy/utilities/interfaces/reimbursement.interface';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@Component({
  selector: 'app-view-reimbursement-item-history',
  templateUrl: './view-reimbursement-item-history.component.html',
  styleUrls: ['./view-reimbursement-item-history.component.scss']
})
export class ViewReimbursementItemHistoryComponent {

  public readonly Helper = Helper;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReimbursementItemHistory[],
  ) { }

}
